// Empty module for Metro resolver
export default null
